import * as types from '../mutation-types'
import core from '@/js/core/core'
import moment from 'moment'
import EventBus from '../../events/event-bus'

// initial state
const state = {
    liveEvent : null,
    selectedLiveEvent: null,
    allSportLang: window.sportLang,
    sportTitle: null,
    liveSchedule:false,
    liveAllBet:false,
    liveMatch:null,
    isOpenTv:1,
}

// getters
const getters = {
    liveEvent: state => state.liveEvent,
    selectedLiveEvent: state => state.selectedLiveEvent,
    allSportLang: state => state.allSportLang,
    sportTitle: state => state.sportTitle,
    liveSchedule: state => state.liveSchedule,
    liveAllBet: state => state.liveAllBet,
    liveMatch: state => state.liveMatch,
    isOpenTv: state => state.isOpenTv,
}

// actions
const actions = {
    getLiveMatch(context, payload) {
        var data = {}
        data.date = payload.date
        data.sportId = payload.sportId
        data.lang = window._langid
        data.action = 'getMatch'
        data.token = payload.token
        core.$ajax({
            method: 'post',
            url: '',
            data: data,
        }).done(((res) => {
            if(res.redirect){
                window.close();
            }
            this.commit('EARLYPARLAYDATELIST', res.earlyParlayDateList);
            this.commit('LIVE_EVENT', res.events)
            if(this.getters.selectedLiveEvent){
                var selectedDate = moment(this.getters.selectedLiveEvent.dt).format('YYYY-MM-DD')
                var findEvent = _.find(res.events[selectedDate], { 'eveid': parseInt(this.getters.selectedLiveEvent.eveid) })
                if(!findEvent){
                    EventBus.$emit('closeTvLink', true )                    
                }
            }
        }).bind(this)).catch((errRes) => {
            console.log(errRes)
        })
    },
    getLiveAllBet(context, payload){
        var data = {
            sprtid: payload.sportId,
            schedule: this.getters.market.inPlayMarket.key,
            lang: window._langid,
            spread: this.getters.account.spread,
            odd: this.getters.account.oddsType,
            evntid: payload.eveid,
            plytypgrp: 1,
        }
        data.sprtid = 'N' + payload.sptid
        if(!payload.redirect){
            var eventDate = new moment(payload.date).locale('en').format("YYYY-MM-DD")
            var filterDateIndex = _.indexOf(this.getters.earlyParlayDateList, eventDate)
            data.date = filterDateIndex != -1 ? filterDateIndex : 0
        }        
        
        data.date = 0
        core.$ajax({
            method: 'post',
            url: _baseUrl + '/sport-allbet',
            data: data
          }).done(((res)=> {
            if(res.redirect){
                window.close();
            }
            this.commit('EVENT_ALLBET', res.allBet)
            if(Object.keys(res.allBet).length > 0 || res.allBet.length > 0){
                this.commit('LIVE_SELECTED_EVENT', _.cloneDeep(res.allBet))
                this.commit('LIVE_SPORT_TITLE', this.getters.allSportLang[res.allBet.sptid]['caption'])                            
            }else{
                this.commit('LIVE_SPORT_TITLE', this.getters.allSportLang[payload.sptid]['caption'])                            
            }
            
          }).bind(this)).catch((errRes)=> {
            console.log(errRes)
          })
    },
    getLiveSchedule(context, payload) {
        var token_val = payload.token
        var data = {}
        data.date = payload.date
        data.sportId = payload.sportId
        data.lang = window._langid
        data.action = 'getMatch'
        data.token = payload.token
        core.$ajax({
            method: 'post',
            url: window._baseUrl + '/livetv',
            data: data,
        }).done(((res) => {
            this.commit('LIVE_EVENT', res.events)
            this.commit('EARLYPARLAYDATELIST',res.earlyParlayDateList);
        }).bind(this)).catch((errRes) => {
            console.log(errRes)
        })
    },
}

// mutations
const mutations = {
    [types.LIVE_EVENT] (state, payload ) {
        state.liveEvent = payload
    },
    [types.LIVE_SELECTED_EVENT] (state, payload ) {
        state.selectedLiveEvent = payload
    },
    [types.LIVE_SPORT_TITLE] (state, payload) {
        state.sportTitle = payload
    },
    [types.LIVE_SCHECULE] (state, payload) {
        state.liveSchedule = payload
    },
    [types.LIVE_ALLBET] (state, payload) {
        state.liveAllBet = payload
    },
    [types.LIVE_MATCH] (state, payload) {
        state.liveMatch = payload
    },
    [types.IS_OPEN_TV] (state, payload) {
        state.isOpenTv = payload
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./resources/wob/vue/store/modules/live-channel.js